export const processTemperatureData = (rawData) => {
    if (!rawData || !rawData.data || !Array.isArray(rawData.data)) {
        return [];
    }

    return rawData.data.map(item => ({
        timestamp: item.timestamp,
        lowest_cell_temp: parseFloat(parseFloat(item.lowest_cell_temp).toFixed(3)) || 0,
        highest_cell_temp: parseFloat(parseFloat(item.highest_cell_temp).toFixed(3)) || 0,
        rectifier_temp: parseFloat(parseFloat(item.rectifier_temp).toFixed(3)) || 0,
        inverter_ambient_temp: parseFloat(parseFloat(item.inverter_ambient_temp).toFixed(3)) || 0,
        inverter_heatsink_temp: parseFloat(parseFloat(item.inverter_heatsink_temp).toFixed(3)) || 0
    }));
};
